import styled, { css } from 'styled-components';

export const Image = styled.img`
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  object-fit: contain;
  [dir='rtl'] & {
    transform: scaleX(-1);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 375px;
  padding: 20px 10px;
  margin: 0 auto;
`;

export const Header = styled.div`
  display: flex;
  gap: 24px;
`;

export const AppColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const AppName = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 21px;
  color: #000;
  white-space: pre-line;
  @media (prefers-color-scheme: dark) {
    color: #fff;
  }
`;

export const AppDescription = styled.div`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #8e8e93;
`;

export const AppButton = styled.button`
  margin-top: 12px;
  padding: 6px 20px;
  border-radius: 1000px;
  background-color: #007aff;
  color: #fff;
  font-size: 16px;
  font-weight: 550;
  line-height: 21px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 0.9;
  }
`;

export const Line = styled.div`
  width: 100%;
  min-height: 1px;
  background-color: rgba(60, 60, 67, 0.13);
  margin: 24px 0 12px;
  @media (prefers-color-scheme: dark) {
    background-color: rgba(255, 255, 255, 0.25);
  }
`;

export const AppRow = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .small {
    font-size: 15px;
  }
`;

export const AppRowItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  gap: 6px;
  width: 94px;
  min-width: 94px;
  padding: 0 8px;
  position: relative;

  &:not(:first-child)::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 50%;
    background-color: rgba(60, 60, 67, 0.13);
    @media (prefers-color-scheme: dark) {
      background-color: rgba(255, 255, 255, 0.25);
    }
  }
  [dir='rtl'] &:not(:first-child)::before {
    left: auto;
    right: 0;
  }
  &:first-child {
    padding-left: 0;
  }
  [dir='rtl'] &:first-child {
    padding-right: 0;
    padding-left: 8px;
  }
  &:last-child {
    padding-right: 0;
  }
  [dir='rtl'] &:last-child {
    padding-left: 0;
    padding-right: 8px;
  }
`;

export const AppRowItemName = styled.div`
  font-size: 11px;
  font-weight: 510;
  line-height: 18px;
  color: #aeaeb2;
  text-align: center;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 92px;
  text-align: start;
  @media (prefers-color-scheme: dark) {
    color: #8e8e93;
  }
`;

export const AppRowItemValue = styled.div`
  display: flex;
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  color: #8e8e93;
  text-align: center;

  span {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.4px;
  }
`;

export const AppRowItemResult = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: #8e8e93;
  max-width: 92px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #000;
  margin: 48px 0 12px;
  @media (prefers-color-scheme: dark) {
    color: #fff;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InfoRowItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const InfoRowItemName = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #aeaeb2;
  span {
    color: #007aff;
  }
  @media (prefers-color-scheme: dark) {
    color: #8e8e93;
  }
`;

export const InfoRowItemValue = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #000;
  display: flex;
  align-items: center;
  gap: 6px;
  @media (prefers-color-scheme: dark) {
    color: #fff;
  }
  &:after {
    ${({ $withIcon }) =>
      $withIcon &&
      css`
        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        -webkit-mask: url('./assets/storeV2/chevron-down.svg') center / contain
          no-repeat;
        mask: url('./assets/storeV2/chevron-down.svg') center / contain
          no-repeat;
        background-color: #aeaeb2;
        @media (prefers-color-scheme: dark) {
          background-color: #8e8e93;
        }
      `}
  }
`;
